import { createContext, type ReactNode, useContext } from 'react';
import { en, type MessageKey } from './en';
import type { Locale } from './locale';

interface I18n {
  /** Язык интерфейса: форматы дат и сортировка, язык писем при регистрации. */
  locale: Locale;
  t: (key: MessageKey) => string;
}

const ENGLISH: I18n = { locale: 'en', t: (key) => en[key] };

const I18nContext = createContext<I18n | null>(null);

export function I18nProvider({ children }: { children: ReactNode }) {
  return <I18nContext value={ENGLISH}>{children}</I18nContext>;
}

export function useI18n(): I18n {
  const context = useContext(I18nContext);
  if (context === null) {
    throw new Error('useI18n() must be used inside <I18nProvider>');
  }
  return context;
}
